/** Admin에 등록되지 않아 Tenant가 연결되지 않은 요청에 표시하는 Company 값. */
export const UNASSIGNED_COMPANY_LABEL = "Not assigned";

/**
 * Company는 Admin에 등록된 고객사명만 표시한다.
 * STUDIO-AUTH-003 기준으로 미등록 도메인은 `tenant_id=null`인 미배정 요청이므로,
 * 이메일 도메인에서 회사명을 추측하지 않고 미배정임을 그대로 알린다.
 */
export const getCompanyLabel = (tenantName?: string | null): string => {
  const resolvedTenantName = tenantName?.trim();
  if (resolvedTenantName) return resolvedTenantName;

  return UNASSIGNED_COMPANY_LABEL;
};
